import { FC, memo } from 'react'
import { Box, Checkbox } from '@chakra-ui/react'

import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import CustomFormCommonEntityCard from 'components/tools/CustomForm/commonComponents/CustomFormCommonEntityCard'
import { useCustomFormCommonEntityPropsManager } from '../../../../contexts/CustomFormCommonEntityPropsManager/Provider'
import { CustomFormCommonEntity } from '../../../../types'

type Props = {
  entity: CustomFormCommonEntity
  onClose: () => void
}

const CustomFormEntityCardToSelect: FC<Props> = ({ entity, onClose }) => {
  const { questionKey, setSelectedEntity, filter } = useCustomFormCommonEntityPropsManager()

  const { formMethods } = useCustomFormViewer()

  function selectEntity(selectedEntity: CustomFormCommonEntity) {
    formMethods?.setValue(questionKey, [selectedEntity.id, selectedEntity.slug, selectedEntity.name], {
      shouldValidate: true,
    })
    setSelectedEntity(selectedEntity)
  }

  // function removeEntity() {
  //   formMethods?.setValue(questionKey, undefined)
  //   setSelectedEntity({})
  // }

  return (
    <CustomFormCommonEntityCard
      entity={entity}
      entityFilter={filter}
      onClick={() => {
        selectEntity(entity)
        onClose()
      }}
    >
      {/* {selectedEntity?.id === entity.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeEntity()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectEntity(entity)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )} */}
      <Box position="absolute" top={2} right={2}>
        <Checkbox size="md" />
      </Box>
    </CustomFormCommonEntityCard>
  )
}

export default memo(CustomFormEntityCardToSelect)
